import Input from "../../components/UI/Input/Input"
import classes from "./Controls.module.css"
import { useTranslation } from "react-i18next"

const RefineMax = props => {
    const { t } = useTranslation()

    return (
        <div className={classes.Wrapper}>
            <p>{t("misc:Recovery.Refine1")}</p>
            <p>{t("misc:Recovery.Refine2")}</p>
            <Input
                title={t("misc:Recovery.RefineCount")}
                type="number"
                val={props.value}
                changed={props.refineHandler}
            />
        </div>
    )
}

export default RefineMax
